import { Link } from "react-router-dom";
import { Facebook, Twitter, Youtube, Instagram, MapPin, Phone, Mail, MessageCircle } from "lucide-react";
import { NAV_LINKS, SOCIALS, CONTACT } from "@/data/content";

const ICONS = { facebook: Facebook, twitter: Twitter, youtube: Youtube, instagram: Instagram };

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="border-t border-white/10 bg-[#0B0B1C]">
            <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-6 md:grid-cols-2 lg:grid-cols-4">
                <div>
                    <img src="/assets/logo.png" alt="Rongeen TV" className="h-11 w-auto rounded-md" />
                    <p className="mt-4 text-xs font-bold uppercase tracking-[0.3em] text-[#FFA200]">Engage · Educate · Entertain</p>
                    <p className="mt-4 text-sm leading-relaxed text-[#9999BB]">
                        Bengal's favourite General Entertainment Channel, reaching 2.5 crore households across Eastern India.
                    </p>
                </div>
                <div>
                    <h4 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white">Quick Links</h4>
                    <ul className="mt-5 space-y-3">
                        {NAV_LINKS.map((link) => (
                            <li key={link.to}>
                                <Link
                                    to={link.to}
                                    data-testid={`footer-link-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                                    className="text-sm text-[#9999BB] transition-colors hover:text-[#FFA200]"
                                >
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div>
                    <h4 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white">Contact</h4>
                    <ul className="mt-5 space-y-4 text-sm text-[#9999BB]">
                        <li className="flex gap-3"><MapPin size={16} className="mt-0.5 shrink-0 text-[#C8102E]" /><span>{CONTACT.address[1]}, {CONTACT.address[2]}<br />{CONTACT.address[3]}</span></li>
                        <li className="flex gap-3"><Phone size={16} className="shrink-0 text-[#C8102E]" /><a href={`tel:${CONTACT.phoneHref}`} data-testid="footer-phone" className="hover:text-[#FFA200]">{CONTACT.phone}</a></li>
                        <li className="flex gap-3"><MessageCircle size={16} className="shrink-0 text-[#C8102E]" /><a href={CONTACT.whatsappHref} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="hover:text-[#FFA200]">{CONTACT.whatsapp}</a></li>
                        <li className="flex gap-3"><Mail size={16} className="shrink-0 text-[#C8102E]" /><a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="hover:text-[#FFA200]">{CONTACT.email}</a></li>
                    </ul>
                </div>
                <div>
                    <h4 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white">Follow Us</h4>
                    <div className="mt-5 flex gap-3">
                        {SOCIALS.map((s) => {
                            const Icon = ICONS[s.icon];
                            return (
                                <a
                                    key={s.name}
                                    href={s.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={s.name}
                                    data-testid={`social-${s.icon}`}
                                    className="rounded-full border border-white/15 p-3 text-white/80 transition-all duration-300 hover:border-[#C8102E] hover:bg-[#C8102E] hover:text-white"
                                >
                                    <Icon size={16} />
                                </a>
                            );
                        })}
                    </div>
                    <p className="mt-6 text-xs leading-relaxed text-[#666688]">{CONTACT.hours}</p>
                </div>
            </div>
            <div className="border-t border-white/10 py-6">
                <p className="px-4 text-center text-xs text-[#666688]">
                    © {new Date().getFullYear()} Rongeen TV. All Rights Reserved. A venture of Biswas Media Solutions Private Limited.
                </p>
            </div>
        </footer>
    );
}
